import { post, get } from '../axios'

// 批量查询shopify collection
export function col_shopify_batch_get_post(map, option) {
  return post(
    `${process.env.VUE_APP_COL}/col/shopify/batch/get`,
    map,
    option
  ).then(response => response)
}

// 同步列表
export function col_shopify_detail_page_post(map, option) {
  return post(
    `${process.env.VUE_APP_COL}/col/shopify/detail/page`,
    map,
    option
  ).then(response => response)
}

// 下载同步数据
export function col_shopify_export_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_COL}/col/shopify/export/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 同步记录列表
export function col_shopify_page_post(map, option) {
  return post(`${process.env.VUE_APP_COL}/col/shopify/page`, map, option).then(
    response => response
  )
}

// 同步
export function col_shopify_sync_post(map, option) {
  return post(`${process.env.VUE_APP_COL}/col/shopify/sync`, map, option).then(
    response => response
  )
}
